import React from "react";
import { ManageTrusteeContainer } from "../../../containers";

const ManageTrustee = (props) => {
  return <ManageTrusteeContainer {...props} />;
};

export default ManageTrustee;
